export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  COMMUNITY_MODERATOR: 'community_moderator',
  ORG_ADMIN: 'org_admin',
  STAFF: 'staff',
  FAMILY_ADMIN: 'family_admin',
  CO_CARER: 'co_carer',
  MEDICAL: 'medical_professional',
  FUNDER: 'funder_ngo',
  FIRST_RESPONDER: 'first_responder',
  EMPLOYER: 'employer',
  VENUE_OWNER: 'venue_owner',
  CANDIDATE: 'candidate',
} as const

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES]

export const ROLE_PERMISSIONS: Record<UserRole, string[]> = {
  [USER_ROLES.SUPER_ADMIN]: [
    'global_sos_map', 'moderate_community', 'aid_oversight',
    'manage_all_users', 'delete_any_account', 'system_settings',
    'create_safety_profile', 'trigger_sos', 'view_all_cameras',
  ],
  [USER_ROLES.COMMUNITY_MODERATOR]: [
    'manage_orgs', 'manage_org_staff', 'view_org_enrollments',
    'approve_org_applications', 'reject_org_applications',
  ],
  [USER_ROLES.ORG_ADMIN]: [
    'manage_staff', 'manage_cohorts', 'manage_billing',
    'create_session_notes', 'start_camera', 'view_center_cameras',
    'create_safety_profile', 'trigger_sos',
  ],
  [USER_ROLES.STAFF]: [
    'create_session_notes', 'start_camera',
    'view_assigned_cameras', 'view_assigned_profiles',
  ],
  [USER_ROLES.FAMILY_ADMIN]: [
    'create_safety_profile', 'edit_own_profiles', 'delete_own_profiles',
    'trigger_sos', 'share_profile', 'view_own_cameras',
  ],
  [USER_ROLES.CO_CARER]: [
    'view_shared_profiles', 'trigger_sos', 'receive_sos_alerts',
  ],
  [USER_ROLES.MEDICAL]: [
    'view_safety_profiles', 'view_session_notes',
  ],
  [USER_ROLES.FUNDER]: [
    'view_aid_applications', 'approve_aid', 'track_disbursements',
  ],
  [USER_ROLES.FIRST_RESPONDER]: [
    'view_public_profile',
  ],
  [USER_ROLES.EMPLOYER]: [
    'post_jobs', 'manage_own_listings', 'view_candidates',
  ],
  [USER_ROLES.VENUE_OWNER]: [
    'post_venues', 'manage_own_venues',
  ],
  [USER_ROLES.CANDIDATE]: [
    'apply_for_jobs', 'view_directory',
  ],
}

export const ROLE_LABELS: Record<UserRole, string> = {
  [USER_ROLES.SUPER_ADMIN]: 'Super Admin',
  [USER_ROLES.COMMUNITY_MODERATOR]: 'Community Moderator',
  [USER_ROLES.ORG_ADMIN]: 'Organization Admin',
  [USER_ROLES.STAFF]: 'Staff',
  [USER_ROLES.FAMILY_ADMIN]: 'Parent / Guardian',
  [USER_ROLES.CO_CARER]: 'Co-Carer',
  [USER_ROLES.MEDICAL]: 'Medical Professional',
  [USER_ROLES.FUNDER]: 'Funder / NGO',
  [USER_ROLES.FIRST_RESPONDER]: 'First Responder',
  [USER_ROLES.EMPLOYER]: 'Employer',
  [USER_ROLES.VENUE_OWNER]: 'Venue Owner',
  [USER_ROLES.CANDIDATE]: 'Candidate',
}
